import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  ConfirmationCodeType,
  LoginUsersClient,
  VerifyCodeCommand,
} from '../../shared/model/fss.api';
import { AuthService } from '../../shared/services/auth.service';
import { LocationService } from '../../shared/services/location.service';
import { LoaderService } from '../../shared/components/loader/loader.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  standalone: true,
  selector: 'app-verify-code',
  imports: [],
  template: '',
})
export class VerifyCode implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _client = inject(LoginUsersClient);
  private readonly _auth = inject(AuthService);
  private readonly _location = inject(LocationService);
  private readonly _loader = inject(LoaderService);
  private readonly _alert = inject(AlertService);

  async ngOnInit() {
    const value = this._route.snapshot.queryParamMap.get('value');
    const code = this._route.snapshot.queryParamMap.get('code');
    const typeRaw = this._route.snapshot.queryParamMap.get('type');
    const type = typeRaw !== null ? (Number(typeRaw) as ConfirmationCodeType) : null;

    if (!value || !code || type === null || Number.isNaN(type)) {
      this._alert.addFailedMsg('Neispravan link.');
      this._location.routeToLogin();
      return;
    }

    this._loader.setLoadingText = 'Provera linka...';
    this._loader.setShowLoader = true;

    try {
      const res = await firstValueFrom(
        this._client.verifyInvitationToken(new VerifyCodeCommand({ value, code, type })),
      );

      if (type === ConfirmationCodeType.PASSWORD_RESET) {
        this._auth.setTokens(res.result.token!, res.result.refreshToken!);
        this._location.routeToResetPassword();
        return;
      }

      if (type === ConfirmationCodeType.EMAIL_VERIFY) {
        this._alert.addSuccessMsg('Email je uspešno potvrđen.');
        this._location.routeToLogin();
        return;
      }

      this._location.routeToLogin();
    } catch {
      this._location.routeToLogin();
    }
  }
}
